import React from 'react'
import { cond, T } from 'ramda'
import { withAuthProvider } from '../../../lib/auth'
import QuickLinks from '../QuickLinks'
import { Side } from '../Panel'
import MSRCreditsBrief, { CompactPDRBrief, NewMSRCreditsBrief, NewCompactPDRBrief } from '../PDRCredits'
import { isMember, isAssociate, isStudent, hasReciprocityAttribute, isB25Class, hasProspectDashboard, isProspectPath } from '../../utils'
import { Loading } from '../CourseCurriculum/CourseCurriculum'
import CourseCurriculum from '../CourseCurriculum'
import PathBox from '../Prospect/PathBox'
import { withProspectDateQuery } from '../../../utils/prospect/withProspectDateQuery'
import { useFeatureFlags } from '../../../lib/feature-flags'
import { flags } from '../../../lib/feature-flags/constants'

const PdrWidget = ({ collapsed }) => {
  const [isPdrRequirementsEnabled] = useFeatureFlags([flags.FLAG_FEAT_MEMBERSHIP_PDR_REQUIREMENTS])

  if (isPdrRequirementsEnabled) return collapsed ? <NewCompactPDRBrief /> : <NewMSRCreditsBrief />
  return collapsed ? <CompactPDRBrief /> : <MSRCreditsBrief />
}

export const chooseAppropriateViewForUser = cond(
  [
    [({ loading }) => loading, () => <Loading />],
    [({ me }) => isMember(me), PdrWidget],
    [({ me }) => isB25Class(me), PdrWidget],
    [({ me }) => isAssociate(me), ({ collapsed }) => collapsed ? <div /> : <CourseCurriculum />],
    [({ me }) => isStudent(me), ({ collapsed }) => collapsed ? <div /> : <CourseCurriculum />],
    [({ me }) => hasReciprocityAttribute(me), ({ collapsed }) => collapsed ? <div /> : <CourseCurriculum />],
    [({ me, currentMember }) => hasProspectDashboard(me) || isProspectPath(currentMember), ({ collapsed }) => collapsed ? <div /> : <PathBox />],
    [T, ({ collapsed }) => <QuickLinks collapsed={collapsed} />]
  ]
)

export const MembershipSailingView = ({ me, authReady, collapsed, currentMember }) => {
  return (
    <Side basis={!collapsed && 55}>
      {chooseAppropriateViewForUser({ me, loading: !authReady, collapsed, currentMember })}
    </Side>
  )
}

export default withProspectDateQuery(withAuthProvider(MembershipSailingView))
